import { V3dSceneManager } from './v3d-scene-manager';
import { Box3, Object3D, PerspectiveCamera, Vector3 } from 'three';
import { globalV3dSettings } from '../data/visualize-3d-global-settings';
import { ViewPoint } from '../models/view-point';
import { getDirectionVector } from '../utility/viewer/camera-utility';

export class V3dPerspectiveSceneManager extends V3dSceneManager<PerspectiveCamera> {
  updateCameraAspectRatio(): void {
    this.camera.aspect = this.canvasWidth / this.canvasHeight;
    this.camera.updateProjectionMatrix();
  }

  fitTargetInView(viewPoint: ViewPoint, target: Object3D): void {
    // TODO: Here the correct solution would be to project the 3d-points (target's vertices) to a 2d-plane aligned with camera view.
    // Then we should take the max(x,y) of the projected points and move camera inwards/outwards of the target based on the camera.fov so that the full object fits in the view.
    // Below is just an approximation which may not fit the full object in the view.
    const bb = new Box3().setFromObject(target);
    const distance = (bb.max.x + bb.max.y + bb.max.z) * 1.25;
    const lookAtPosition = new Vector3();
    const direction = getDirectionVector(viewPoint).multiplyScalar(distance);
    const position = lookAtPosition.add(direction);
    this.camera.position.copy(position);
    this.controls.update();
  }

  lookAtObjectFromViewPoint(viewPoint: ViewPoint, target: Object3D, fitToView = false): void {
    this.lookAt(target, viewPoint, fitToView);
  }
}

export const createDefaultPerspectiveCamera = (canvasWidth: number, canvasHeight: number) => {
  const camera = new PerspectiveCamera(
    globalV3dSettings.cameraFov,
    canvasWidth / canvasHeight,
    globalV3dSettings.cameraNearPlane,
    globalV3dSettings.cameraFarPlane,
  );
  camera.up.copy(globalV3dSettings.upVector);
  camera.aspect = canvasWidth / canvasHeight;

  return camera;
};
